export const infrastructureEquipment = {
  backbone: {
    planned: false,
    installed: false
  },
  leadIn: {
    planned: false,
    installed: false
  },
  customerAccessCabling: {
    planned: false,
    installed: false
  },
  gPOinMDF: {
    planned: false,
    installed: false,
    exist: false
  },
  uPSinMDF: {
    planned: false,
    installed: false
  },
  gPOinRisers: {
    planned: false,
    installed: false,
    exist: false
  },
  uPSinRisers: {
    planned: false,
    installed: false
  }
}
